import React from 'react'
import { Form, FloatingLabel } from "react-bootstrap";

//customize input
function CustomInput({ icon,label, type, value, placeholder, onChange,onKeyDown1 }) {
    return (
        <div>
            <div className="form-outline rgc-input-icons">
                <i className={icon}></i>
                <FloatingLabel controlId="floatingInput" label={label.includes(":") ? label.replace(":", "") : label}>
                    <Form.Control
                        required
                        type={type}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        onKeyDown={onKeyDown1}
                        className="rgc-input-floating"
                    />
                </FloatingLabel>
                <br />
            </div>

        </div>
    )
}

export default CustomInput